
  /*
  * 文件名称处理函数
  * fileName 原文件名称，拿去文件后缀
  * return dealFileName  返回处理后的文件名称（日期时间(时分秒)+）
  */
  function get_uni_file_name(fileName)
  {
    
    var date = getCurrentDate(3);
    var uniStr = guid2();
    var etx = get_suffix(fileName);
    var dealFileName = date+uniStr+etx;
    return dealFileName;
  }

function guid2() {
      
  function S4() {
  
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
 //    获取文件 后缀
 function get_suffix(fileName) {
  var index1 = fileName.lastIndexOf('.')
  var index2 = fileName.length
  var suffix = fileName.substring(index1, index2) //后缀名
  return suffix
}

// 获取当前时间
/**
	 *获取当前时间
	 *format=1精确到天
	 *format=2精确到分
	*/
	function getCurrentDate(format) {
	  var now = new Date();
   
	  var year = now.getFullYear(); //得到年份
    
	  var month = now.getMonth();//得到月份
	  var date = now.getDate();//得到日期
	  var day = now.getDay();//得到周几
	  var hour = now.getHours();//得到小时
	  var minu = now.getMinutes();//得到分钟
	  var sec = now.getSeconds();//得到秒
	  month = month + 1;
	  if (month < 10) month = "0" + month;
	  if (date < 10) date = "0" + date;
	  if (hour < 10) hour = "0" + hour;
	  if (minu < 10) minu = "0" + minu;
	  if (sec < 10) sec = "0" + sec;
	  var time = "";
	  //精确到天
	  if(format==1){
		time = year.toString() + "-" + month + "-" + day;
	  }
	  //精确到分
	  else if(format==2){
		time = year.toString() + "-" + month + "-" + day+ " " + hour + ":" + minu + ":" + sec;
	  }//需要的文件日期
	  else if(format==3){
      time = year.toString() + month.toString() + day.toString()+"/"+hour + minu + sec+"-";
      }
     
	  return time;
	}


export {			//关键
	get_uni_file_name
}


 






// WEBPACK FOOTER //
// ./src/tools/tools.js